var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 800,
    viewBox: "0 0 592 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.583 274.998C189.25 274.998 182.917 272.665 177.917 267.665L112.25 201.998L46.5833 267.665C36.9167 277.331 20.9167 277.331 11.25 267.665C1.58333 257.998 1.58333 241.998 11.25 232.331L94.5833 148.998C104.25 139.331 120.25 139.331 129.917 148.998L213.25 232.331C222.917 241.998 222.917 257.998 213.25 267.665C208.25 272.665 201.917 274.998 195.583 274.998Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.25 658.333C98.5833 658.333 87.25 647 87.25 633.333V166.667C87.25 153 98.5833 141.667 112.25 141.667C125.917 141.667 137.25 153 137.25 166.667V633.333C137.25 647 125.917 658.333 112.25 658.333Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M562.25 275H295.583C281.916 275 270.583 263.667 270.583 250C270.583 236.333 281.916 225 295.583 225H562.25C575.916 225 587.25 236.333 587.25 250C587.25 263.667 575.916 275 562.25 275Z",
    fill: "#D3D3D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M428.916 475H295.583C281.916 475 270.583 463.667 270.583 450C270.583 436.333 281.916 425 295.583 425H428.916C442.583 425 453.916 436.333 453.916 450C453.916 463.667 442.583 475 428.916 475Z",
    fill: "#D3D3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M362.25 575H295.583C281.916 575 270.583 563.667 270.583 550C270.583 536.333 281.916 525 295.583 525H362.25C375.916 525 387.25 536.333 387.25 550C387.25 563.667 375.916 575 362.25 575Z",
    fill: "#D3D3D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M495.583 375H295.583C281.916 375 270.583 363.667 270.583 350C270.583 336.333 281.916 325 295.583 325H495.583C509.25 325 520.583 336.333 520.583 350C520.583 363.667 509.25 375 495.583 375Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSortUp);
export default __webpack_public_path__ + "static/media/ico_sort_up.4dee247d3229be5e001b2208e9975258.svg";
export { ForwardRef as ReactComponent };